import axios from 'axios';
import _ from 'lodash';

const SPEAKERS_API = 'https://8ej34nhr3c.execute-api.eu-west-1.amazonaws.com/prod';
const TALKS_API = 'https://pui1uplwt0.execute-api.eu-west-1.amazonaws.com/dev';

const sendAPIRequest = async ({ method = 'GET', url, data }) => {
    try {
        return await axios({
            method,
            url,
            data
        });
    } catch (error) {
        throw error;
    }
};

export const submitCallForSpeakers = formData => {
    const data = Object.keys(formData).reduce((prev, field) => {
        const tempPrev = prev;

        if (field === 'speakers') {
            tempPrev.speakers = formData.speakers.map(speaker => ({
                speakerName: speaker.speakerName.value,
                email: speaker.email.value,
                company: speaker.company.value,
                country: speaker.country.value,
                speakerBio: speaker.speakerBio.value,
                photoLink: speaker.photoLink.value
            }));
            return tempPrev;
        }

        tempPrev[field] = _.escape(formData[field].value);
        return tempPrev;
    }, {});
    return sendAPIRequest({
        method: 'POST',
        url: 'https://tn85qtho26.execute-api.eu-west-1.amazonaws.com/dev/cfs',
        data
    });
};

export const submitConferenceFF = async data =>
    sendAPIRequest({
        method: 'POST',
        url:
            'https://mp45zzgm5e.execute-api.eu-west-1.amazonaws.com/prod/feedback-forms/conference',
        data
    });

export const submitWorkshopFF = async data =>
    sendAPIRequest({
        method: 'POST',
        url: 'https://mp45zzgm5e.execute-api.eu-west-1.amazonaws.com/prod/feedback-forms/workshops',
        data
    });

export const getSpeakers = async () => {
    try {
        const speakers = await axios.get(`${SPEAKERS_API}/speakers`);
        const data =
            typeof speakers.data === 'string'
                ? JSON.parse(speakers.data.replace(/(?:\r\n\t|\r|\n|\t)/g, ' '))
                : speakers.data;
        return data;
    } catch (error) {
        throw error;
    }
};

export const getSpeakerDetails = async speakerId => {
    try {
        const speakersDetails = await axios.get(`${SPEAKERS_API}/speaker-details/${speakerId}`);
        const data =
            typeof speakersDetails.data === 'string'
                ? JSON.parse(speakersDetails.data.replace(/(?:\r\n\t|\r|\n|\t)/g, ' '))
                : speakersDetails.data;
        return data;
    } catch (error) {
        throw error;
    }
};

export const getTalkDetails = async talkId => {
    try {
        const talkDetails = await axios.get(`${TALKS_API}/talk-details/${talkId}`);
        const data =
            typeof talkDetails.data === 'string'
                ? JSON.parse(talkDetails.data.replace(/(?:\r\n\t|\r|\n|\t)/g, ' '))
                : talkDetails.data;
        return data;
    } catch (error) {
        throw error;
    }
};

export const getProgram = async () => {
    try {
        const programStructure = await axios.get(`${TALKS_API}/program`);
        return programStructure.data;
    } catch (error) {
        throw error;
    }
};

export const getWorkshopProgram = async () => {
    try {
        const programStructure = await axios.get(`${TALKS_API}/workshop-program`);
        return programStructure.data;
    } catch (error) {
        throw error;
    }
};
